import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { motion } from "framer-motion";
import { useCart } from "@/context/CartContext";
import { eur } from "@/lib/api";

export const ProductCard = ({ product, index = 0 }) => {
  const { add } = useCart();
  return (
    <motion.article
      initial={{ opacity: 0, y: 44 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-4%" }}
      transition={{ duration: 0.85, delay: (index % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
      className="group"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/negozio/${product.id}`} data-testid={`product-link-${product.id}`}>
        <div className="arch-frame aspect-[3/4] overflow-hidden bg-sand">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        </div>
      </Link>
      <div className="mt-5 flex items-start justify-between gap-4">
        <div>
          <p className="font-accent text-[10px] uppercase tracking-[0.22em] text-moss">{product.category}</p>
          <h3 className="mt-1 font-serif text-xl leading-snug text-forest">{product.name}</h3>
        </div>
        <p className="whitespace-nowrap font-serif text-lg text-forest">{eur(product.price)}</p>
      </div>
      <button
        onClick={() => add(product)}
        data-testid={`add-to-cart-${product.id}`}
        className="mt-3 flex items-center gap-2 rounded-full border border-forest px-5 py-2.5 font-accent text-xs uppercase tracking-[0.2em] text-forest transition-colors duration-300 hover:bg-forest hover:text-bone active:scale-95"
      >
        <Plus className="h-3.5 w-3.5" /> Aggiungi
      </button>
    </motion.article>
  );
};
